var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h1"},[_c('div',{staticClass:"d-flex justify-center pt-12"},[_c('p',{staticClass:"text--secondary"},[_vm._v("EROR "),_c('span',{staticClass:"dr-eror-text-container"},[_vm._v("404")])])]),_c('div',{staticClass:"d-flex justify-center pt-12 text--secondary"},[_vm._v("PAGE NOT FOUND")])])
}]

export { render, staticRenderFns }